module.exports = __webpack_public_path__ + "static/img/desk-about.cb0ec47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/svg-img/desk-about.svg
// module id = 1348
// module chunks = 173